module.exports = __webpack_public_path__ + "media/images/icons/download-icon-8350ece4ac0da7bd6c15188e401266fa.svg";